var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('p',{class:_vm.className ? _vm.className : 'font-weight-bold primary--text mb-2'},[_vm._v(" ▼ "+_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }